import * as service from './signupconfirm.service.js'


export default {

  data() {
    return {
      signupConfirmError: '',
      OrganizationName: '',
      useremail: '',
      userpassword: '',
      OrganisationName: '',
      signupConfirmsucess: '',
      passClicked: false,

      Gender: [{
        value: 'M',
        label: 'Male'
      }, {
        value: 'F',
        label: 'Female'
      }],

      signupFormconfirm: {
        firstname: '',
        lastname: '',
        mobile: '',
        gender: '',
        location: '',
        pool: ''



      },
      rules: {
        firstname: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }

        ],
        lastname: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }

        ],
        mobile: [
          // { required: true, message: 'This field is required' },
          {
            min: 1,
            max: 20,
            message: 'Length should be 1 to 20'
          }

        ],
        // gender: [
        //   { required: true, message: 'This field is required' }

        // ],
        location: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,                            //CHANGED 20 to 50 - 20200730-FG-0003
            message: 'Length should be 1 to 50' //CHANGED 20 to 50 - 20200730-FG-0003
          }

        ],
        //20200804-FG-0004 & 20200811-FG-0001 - replaced how pool is handled so that it is now required
        pool: [{
          required: true,
          message: 'This field is required'
        },
        {
          min: 1,
          max: 50,                            //CHANGED 20 TO 50 - 20200730-FG-0004
          message: 'Length should be 1 to 20' //CHANGED 20 TO 50 - 20200730-FG-0004
        }
      ]
        //CODE PRIOR TO 20200804-FG-0004 is below
        //pool: [
        //  // { required: true, message: 'This field is required' },
        //  {
        //    min: 1,
        //    max: 20,
        //    message: 'Length should be 1 to 20'
        //  }
        //]

      }

    }
  },

  mounted() {

    let context = this;
    var auth = JSON.parse(context.$localStorage.get('authentication'))
    if (auth) {


    } else {
      context.$localStorage.remove('authentication')
      context.$router.push('/login')
    }
    this.OrganizationName = auth ? auth.OrganizationName : '';

  },
  methods: {

    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    checkSpace() {

      if (this.OrganizationName) {
        this.OrganizationName = this.OrganizationName.replace(/^\s+|\s+$/g, '')

      }

      if (this.signupFormconfirm.firstname) {
        this.signupFormconfirm.firstname = this.signupFormconfirm.firstname.replace(/^\s+|\s+$/g, '')
      }
      if (this.signupFormconfirm.lastname) {
        this.signupFormconfirm.lastname = this.signupFormconfirm.lastname.replace(/^\s+|\s+$/g, '')
      }

      if (this.signupFormconfirm.mobile) {
        this.signupFormconfirm.mobile = this.signupFormconfirm.mobile.replace(/^\s+|\s+$/g, '')
      }
      if (this.signupFormconfirm.location) {
        this.signupFormconfirm.location = this.signupFormconfirm.location.replace(/^\s+|\s+$/g, '')
      }
      if (this.signupFormconfirm.pool) {
        this.signupFormconfirm.pool = this.signupFormconfirm.pool.replace(/^\s+|\s+$/g, '')
      }

    },

    togglePassword() {

      if (!this.passClicked) {
        $('#password').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#password').children().attr('type', 'password')
        this.passClicked = false
      }

    },

    alertClose() {
      $('.alert').hide()
    },



    submitForm(formName) {;
      this.signupConfirmError = ''
      let context = this
      this.$refs[formName].validate((valid) => {

        if (valid) {
          loader.startLoader();
          var model = {
            OrganizationName: this.OrganizationName,
            FirstName: this.signupFormconfirm.firstname,
            LastName: this.signupFormconfirm.lastname,
            PhoneNumber: (this.signupFormconfirm.mobile) ? this.signupFormconfirm.mobile : "",
            Gender: (this.signupFormconfirm.gender) ? this.signupFormconfirm.gender : "",
            Location: this.signupFormconfirm.location,
            Pool: this.signupFormconfirm.pool
          }


          service.signupConfirm(model).then(function (response) {

            loader.stopLoader()
            $('.alert').show()

            var auth = JSON.parse(context.$localStorage.get('authentication'))


             auth["IsFirstLogin"]="False";
            
            auth.FirstName = context.signupFormconfirm.firstname
            auth.LastName = context.signupFormconfirm.lastname
            context.$localStorage.set('authentication', JSON.stringify(auth))
            context.$router.app.$emit('invocksidebar', true)
            //context.$router.push('/AdminDashboard')
            //FG - FOOF - 20200811-FG-0001
            //IF I PUSH THE DIRECTOR TO THE DASHBOARD INSTEAD OF THE ADD PERSONNEL PAGE
            //AFTER THE CONFIRM PAGE (KICKSTART PAGE) WILL THEY THEN SEE THEMSELVES ON
            //THAT PERSONNEL PAGE ??????
            //context.$router.push('/addpersonnel')
            context.$router.push('/dashboard') //SEND TO DASHBOARD INSTEAD OF ADD PERSONNEL!!!!!

          }).catch((error) => {

            var message = error.responseText;
            var parsed = JSON.parse(message);
            this.signupConfirmError = parsed.Message;
            loader.stopLoader()
            $('.alert').show()
          })

        } else {

          this.$notify({

            title: 'Error',

            message: 'SIGNUP CONFIRM - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

  }

}



// WEBPACK FOOTER //
// ./src/pages/signupconfirm/signupconfirm.controller.js